import { DateTime } from "luxon";
import { useEffect, useState } from "react";

export const useInputHandler = () => {
	const [title, setTitle] = useState<string>("Sorteo público");
	const [description, setDescription] = useState<string>("");
	const [date, setDate] = useState<string>("");
	const [hour, setHour] = useState<string>("");
	const [valueInputParticipant, setValueInputParticipant] = useState<string>("");
	const [valueInputPrize, setValueInputPrize] = useState<string>("");
	const [listParticipant, setListParticipant] = useState<string[]>([]);
	const [listPrizes, setListPrizes] = useState<string[]>([]);
	const [inputError, setInputError] = useState({
		title: false,
		participant: false,
		prize: false,
		date: false,
		hour: false,
	});
	useEffect(() => {
		const now = DateTime.now();
		const formattedDate = now.toISODate();
		setDate(formattedDate);
		const updatedHour = now.plus({ minutes: 5 }).toFormat("HH:mm");
		setHour(updatedHour);
	}, []);
	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, type: "participant" | "prize" | "title" | "date" | "hour") => {
		const currentValue = e.target.value;
		if (type === "participant" || type === "prize") {
			if (currentValue.includes(",") && currentValue.trim() !== ",") {
				if (type === "participant") {
					setListParticipant((prevList) => [...prevList, currentValue.replace(",", "").trim()]);
					setValueInputParticipant("");
				} else if (type === "prize") {
					setListPrizes((prevList) => [...prevList, currentValue.replace(",", "").trim()]);
					setValueInputPrize("");
				}
			} else {
				if (currentValue.trim() === ",") return;
				if (type === "participant") {
					setValueInputParticipant(currentValue);
				} else if (type === "prize") {
					setValueInputPrize(currentValue);
				}
			}
		} else {
			if (type === "title") setTitle(currentValue);
			else if (type === "date") setDate(currentValue);
			else if (type === "hour") setHour(currentValue);
		}
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, type: "participant" | "prize" | "title" | "date" | "hour") => {
		if (e.key === "Enter" && (valueInputParticipant.trim() !== "" || valueInputPrize.trim() !== "")) {
			if (type === "participant") {
				setListParticipant((prevList) => [...prevList, valueInputParticipant.trim()]);
				setValueInputParticipant("");
			} else if (type === "prize") {
				setListPrizes((prevList) => [...prevList, valueInputPrize.trim()]);
				setValueInputPrize("");
			}
		}
	};

	return {
		title,
		setTitle,
		description,
		setDescription,
		date,
		setDate,
		hour,
		setHour,
		valueInputParticipant,
		setValueInputParticipant,
		valueInputPrize,
		setValueInputPrize,
		listParticipant,
		setListParticipant,
		listPrizes,
		setListPrizes,
		inputError,
		setInputError,
		handleInputChange,
		handleKeyDown,
	};
};
